import React from 'react';
import ProjectAdminDashboard from '../components/admin/ProjectAdminDashboard';

const ProjectAdminPage: React.FC = () => {
  return <ProjectAdminDashboard />;
};

export default ProjectAdminPage; 